// The version also replaces cached placeholders on existing installations.
export const DEFAULT_USER_AVATAR = '/assets/images/global/user.jpg?v=flat-square-1';
export const SENSITIVE_USER_AVATAR = '/assets/images/global/user_sensitive_img.jpg?v=flat-square-1';
